import React, { useState } from "react";
import styles from "./NumberSequence.module.css";
import { updateScore } from "../../utils/storage";

const NumberSequence = ({ goHome }) => {
  const [sequence, setSequence] = useState([]);
  const [input, setInput] = useState("");
  const [showNumbers, setShowNumbers] = useState(false);
  const [level, setLevel] = useState(1);
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [feedback, setFeedback] = useState("");

  const generateSequence = (size) => {
    return Array.from({ length: size }, () =>
      Math.floor(Math.random() * 9) + 1
    );
  };

  // 🔥 NOVO BALANCEAMENTO
  const getSequenceSize = () => {
    if (level < 5) return 3 + Math.floor(level / 2);
    if (level < 10) return 5 + Math.floor(level / 3);
    if (level < 20) return 7 + Math.floor(level / 4);
    return 10 + Math.floor(level / 5);
  };

  const startRound = () => {
    const newSeq = generateSequence(getSequenceSize());

    setSequence(newSeq);
    setShowNumbers(true);
    setInput("");
    setFeedback("");

    const showTime = Math.max(1200, 2000 + level * 120);

    setTimeout(() => {
      setShowNumbers(false);
    }, showTime);
  };

  const checkAnswer = () => {
    if (input === sequence.join("")) {
      const newScore = score + level * 20;

      setScore(newScore);
      setLevel(level + 1);
      setFeedback("✔ Boa! Vamos pro próximo nível");

      updateScore("sequence", newScore);
      window.dispatchEvent(new Event("ml_update"));

      setTimeout(() => {
        startRound();
      }, 800);
    } else {
      setFeedback("❌ Errou!");
      setGameOver(true);

      updateScore("sequence", score);
      window.dispatchEvent(new Event("ml_update"));
    }
  };

  const restart = () => {
    setSequence([]);
    setInput("");
    setShowNumbers(false);
    setLevel(1);
    setScore(0);
    setGameOver(false);
    setFeedback("");
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>🔢 Memória Sequencial</h3>

      {!gameOver && (
        <>
          <div className={styles.info}>
            <span>Nível: {level}</span>
            <span>Pontos: {score}</span>
          </div>

          <div className={styles.sequenceBox}>
            {showNumbers ? sequence.join(" ") : "?"}
          </div>

          {!showNumbers && sequence.length > 0 && (
            <div className={styles.inputArea}>
              <input
                className={styles.input}
                value={input}
                onChange={(e) => setInput(e.target.value)}
                placeholder="Digite a sequência..."
              />

              <button className={styles.button} onClick={checkAnswer}>
                Confirmar
              </button>
            </div>
          )}

          <p className={styles.feedback}>{feedback}</p>

          <div className={styles.actions}>
            {/* 🔥 BOTÃO SÓ ANTES DE INICIAR */}
            {sequence.length === 0 && (
              <button className={styles.button} onClick={startRound}>
                Iniciar Rodada
              </button>
            )}

            <button className={styles.buttonSecondary} onClick={goHome}>
              Voltar
            </button>
          </div>
        </>
      )}

      {gameOver && (
        <div className={styles.resultBox}>
          <h3>🏁 Fim de Jogo</h3>

          <p>Pontuação: {score}</p>

          <button className={styles.button} onClick={restart}>
            Jogar Novamente
          </button>

          <button className={styles.buttonSecondary} onClick={goHome}>
            Voltar
          </button>
        </div>
      )}
    </div>
  );
};

export default NumberSequence;